import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

export const ColorLabel = styled.div`
  width: ${props => props.width ? props.width : '16px'};
  height: ${props => props.height ? props.height : '16px'};
  background-color: ${(props) => props.color || '#9b27af'};
  border: ${(props) => props.borderColor ? `1px solid ${props.borderColor}`: 'none'};
  border-radius: ${(props) => props.borderRadius ?? '0'};
  display: inline-block;
  margin: 8px;
`;

export const DropField = styled(Dropdown)`
  /* height: 100%; */
  .btn.show {
    color: #3e4957;
    background-color: white;
  }
  .dropdown-menu.show {
    width: 100%;
    max-height: 300px;
    overflow: scroll;
  }
  button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #3e4957;
    background-color: white;
    border: none;
    box-shadow: none !important;
    &::after {
      display: none;
    }

    &:hover {
      color: #3e4957;
      background-color: white;
    }
    &:active {
      background-color: white !important;
      color: #3e4957 !important;
    }
  }
  .dropdown-item {
    &:active {
      color: var(--bs-dark);
      text-decoration: none;
      background-color: #e9ecef;
    }
  }
`;
